import React, { useEffect } from "react";
import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { getTableColumns, getTableData } from "../../models/restaurantModel";
import Table from "../../components/common/table/Table";
import ActionDropdown from "../../components/actions/ActionDropdown";

import {
    deleteRestaurant,
    fetchRestaurants,
    resetCreateStatus,
    resetManageOwnerStatus,
    resetManageUserStatus,
    resetUpdateStatus
} from "../../store/restaurant-slice";
import {useSearchParams} from "react-router-dom";

const RestaurantView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        manageUserStatus,
        manageOwnerStatus,
        pagination,
        error
    } = useSelector(state => state.restaurant);

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchRestaurants({page: initialPage, limit: initialLimit}));
    }, [dispatch, initialPage, initialLimit]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    useEffect(() => {
        if (manageUserStatus === "success") {
            dispatch(resetManageUserStatus());
        }
    }, [dispatch, manageUserStatus]);

    useEffect(() => {
        if (manageOwnerStatus === "success") {
            dispatch(resetManageOwnerStatus());
        }
    }, [dispatch, manageOwnerStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteRestaurant(id));
    };

    const tableColumns = getTableColumns({ ActionDropdown, deleteHandler });
    const tableData = getTableData({ items });

    return (
        <>
            <SubHeader title="All Restaurants">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && <Table className="mobile-responsive" columns={tableColumns} data={tableData} pagination={pagination}/>}
        </>
    );
};

export default RestaurantView;
